import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MyAccountContainer } from '@components/organisms/MyAccountContainer';
import { SITE_URLS } from '@constants';
import { usePermissionChecker, UserPermissions } from '@hooks/useHasPermission';
import { useCustomNavigate } from '@hooks/useCustomNavigate';
import { WorkerForm } from '@components/molecules/WorkerForm';
import { useParams } from 'react-router';

export const ManageWorkersCreate: FC = () => {
    const { navigate } = useCustomNavigate();
    const { store } = useParams();
    const { can } = usePermissionChecker();
    const { t } = useTranslation();

    const translations = {
        title: t('manage-workers-create-component.title'),
    };

    // if user does not have permission accessMerchantAreas, he can't access this page
    useEffect(() => {
        if (can(UserPermissions.accessMerchantAreas) === false) {
            navigate(`/${SITE_URLS.myWorkers}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <MyAccountContainer title={translations.title}>
            <div className="pt-4">
                <WorkerForm edit={false} storeUuid={store ?? ''} />
            </div>
        </MyAccountContainer>
    );
};
